import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=da6821a8&scoped=true&"
import script from "./Gallery.vue?vue&type=script&lang=js&"
export * from "./Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Gallery.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Gallery.vue?vue&type=style&index=1&id=da6821a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6821a8",
  null
  
)

export default component.exports